import { useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import debounce from "../../helpers/debounce";
import {
  hideFilterOverlay,
  updateViewportCategory,
  updateClientWidth
} from "../../state/modules/layout/actions";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout/constants";

const DEBOUNCE_TIMEOUT = 200;
export const SMALL_VIEWPORT_MAX_SIZE = 768;
export const MEDIUM_VIEWPORT_MAX_SIZE = 1024;

export const getViewportSize = () => {
  const size = window.innerWidth;
  if (size < SMALL_VIEWPORT_MAX_SIZE) {
    return SMALL_VIEWPORT;
  } else if (size < MEDIUM_VIEWPORT_MAX_SIZE) {
    return MEDIUM_VIEWPORT;
  }

  return LARGE_VIEWPORT;
};

export const LayoutManager = () => {
  const dispatch = useDispatch();
  const viewportSizeRef = useRef(null);
  const clientWidthRef = useRef(null);

  const handleUpdateViewportCategory = useCallback(() => {
    const viewportSize = getViewportSize();
    if (viewportSize === viewportSizeRef.current) {
      return;
    }
    if (viewportSize === LARGE_VIEWPORT) {
      dispatch(hideFilterOverlay());
    }
    dispatch(updateViewportCategory(viewportSize));
    viewportSizeRef.current = viewportSize;
  }, [dispatch]);

  const handleUpdateClientWidth = useCallback(
    newWidth => {
      if (newWidth !== clientWidthRef.current) {
        dispatch(updateClientWidth(newWidth));
        clientWidthRef.current = newWidth;
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const onResize = debounce(() => {
      handleUpdateViewportCategory();
      handleUpdateClientWidth(document.body.clientWidth);
    }, DEBOUNCE_TIMEOUT);

    // Initial call on mount
    onResize();

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [handleUpdateViewportCategory, handleUpdateClientWidth]);

  return null;
};

export default LayoutManager;
